import { take, call, put, fork } from 'redux-saga/effects';
import {
  fetchQuestionList,
  successQuestionList,
  fetchUpdateQuestionList,
  failUpdateQuestionList,
  successUpdateQuestionList,
  setMarker,
  failSetMarker,
  successSetMarker,
} from '../actions/question';
import division1 from '../data/division1.json';
import division2 from '../data/division2.json';
import division3 from '../data/division3.json';
import sheet from '../data/sheet.json';
import questions from '../data/question.json';
import s_division2 from '../data/s_division2.json';
import s_division3 from '../data/s_division3.json';
import s_sheet from '../data/s_sheet.json';
import explanation from '../data/explanation.json';

import superFetch from '../modules/superFetch';
import { actions } from 'react-redux-form';
import moment from 'moment';
import _ from 'lodash';

import store from '../store/configureStore';

// [redux-saga] ...非同期処理を取り扱う仕組み
// 関数を作成したらモジュールの最後尾 saga()にてFork する事。
// while(true) で待機状態を作る。
// yield take(`${actionName}`) に定義したアクション名を受け取ると発火する。
// アクション名は ../actions/{module_name}.js にて定義する。
// 発火させるには component にて this.props.dispatch(actionName());
// disaptchしたものは 戻り値.payloadで取り出せる。
// action関数の引数は sagaに渡される前に reducer/{module_name}.jsにて処理され
// stateの状態変更を行っている

export function* handleFetchQuestionList() {
  while (true) {
    yield take(`${fetchQuestionList}`);

    const data = {
      division1,
      division2,
      division3,
      sheet,
      questions,
      s_division2,
      s_division3,
      s_sheet,
      explanation,
    };
    yield put(successQuestionList(Object.assign({}, data)));
    continue;
  }
}

export function* handleFetchUpdateQuestionList() {
  while (true) {
    const action = yield take(`${fetchUpdateQuestionList}`);
    const forms = store.getState().form;
    let data = {};
    if (!action.payload || !action.payload.lastFetchTime) {
      data.lastFetchTime = forms.global.lastFetchTime;
    } else {
      data = action.payload;
    }

    const { payload, err } = yield call(superFetch, {
      url: '/api/question/update',
      type: 'POST',
      data: data,
    });

    if (payload && !err) {
      let question = store.getState().question;
      _.map(payload.question, (data) => {
        question.questions = _.reject(question.questions, { id: data.id });
        if (data.delete_flag === '0' && data.disabled_flag === '0') {
          question.questions.push(data);
        }
      });
      _.map(payload.division1, (data) => {
        question.division1 = _.reject(question.division1, { id: data.id });
        if (data.delete_flag === '0' && data.disabled_flag === '0') {
          question.division1.push(data);
        }
      });
      _.map(payload.division2, (data) => {
        question.division2 = _.reject(question.division2, { id: data.id });
        if (data.delete_flag === '0' && data.disabled_flag === '0') {
          question.division2.push(data);
        }
      });
      _.map(payload.division3, (data) => {
        question.division3 = _.reject(question.division3, { id: data.id });
        if (data.delete_flag === '0' && data.disabled_flag === '0') {
          question.division3.push(data);
        }
      });
      _.map(payload.sheet, (data) => {
        question.sheet = _.reject(question.sheet, { id: data.id });
        if (data.delete_flag === '0' && data.disabled_flag === '0') {
          question.sheet.push(data);
        }
      });
      question.updates = payload;

      yield put(successUpdateQuestionList(Object.assign({}, question)));
      yield put(
        actions.change(
          'forms.global.lastFetchTime',
          moment().format('YYYY-MM-DD HH:mm')
        )
      );
      continue;
    }
    yield put(failUpdateQuestionList(err));
  }
}
export function* handleSetMarker() {
  while (true) {
    const action = yield take(`${setMarker}`);
    const jwt = localStorage.getItem('jwt');
    const { payload } = action;
    let data = {
      id: payload.id,
      selection_data: payload.selection_data,
    };
    const { payload: res, err } = yield call(superFetch, {
      url: '/api/question/setmarker',
      type: 'POST',
      data: data,
      custom: {
        headers: {
          authorization: `Bearer ${jwt}`,
        },
      },
    });
    let questions = store.getState().question;
    let question = _.find(questions.questions, { id: payload.id });
    let rejected = _.reject(questions.questions, { id: payload.id });
    question = Object.assign({}, question, {
      selection_data: payload.selection_data,
    });
    rejected.push(question);

    if (res && !err) {
      yield put(successSetMarker(rejected));

      continue;
    }
    yield put(failSetMarker(err));
  }
}

//作った関数をまとめて form 関数名 saga() の変更は必要無し。
export default function* saga() {
  yield fork(handleFetchQuestionList);
  yield fork(handleFetchUpdateQuestionList);
  yield fork(handleSetMarker);
}



// WEBPACK FOOTER //
// ./src/sagas/question.js